/* Sulu link anchor fix */
document.addEventListener('DOMContentLoaded', () => {
	[...document.querySelectorAll('[data-anchor-link]')].forEach((element) => {
		const anchor = element.querySelector('a');

		if (anchor) {
			const anchorTarget = element.dataset.anchorLink;
			const href = anchor.getAttribute('href');

			anchor.setAttribute('href', `${href ? href : ''}#${anchorTarget}`);
		}
	});
});
